import videoSliderInstance, { Swiper, Mousewheel } from 'swiper/core';

videoSliderInstance.use(Mousewheel);

const videoSliderEl = document.querySelectorAll('.c-slider--video');

if (videoSliderEl) {
  videoSliderEl.forEach(slider => {
    const { slideCount, slideOffset } = slider.dataset;
    const options = {
      mousewheel: true,
      init: false,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: slideOffset ? Number(slideCount) - 1 : slideCount,
        },
      },
    };
    const videoSlider = new Swiper(slider, options);

    videoSlider.init();
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/videoSlider.js